package com.appsyde.shared.modules.team.domain.usecase

import com.appsyde.shared.modules.team.domain.model.TeamInvite
import com.appsyde.shared.modules.team.domain.repository.TeamRepository

class GetTeamInvitesUseCase(
    private val repository: TeamRepository
) {
    suspend operator fun invoke(): List<TeamInvite> = repository.getInvites()
}
